// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"85d1931b","498":"b4766843","703":"6f94e138"}[chunkId] + ".chunk.js";
};